var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 21,
    viewBox: "0 0 27 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4688 0.75H2.53125C1.10742 0.75 0 1.91016 0 3.28125V18.4688C0 19.8926 1.10742 21 2.53125 21H24.4688C25.8398 21 27 19.8926 27 18.4688V3.28125C27 1.91016 25.8398 0.75 24.4688 0.75ZM24.4688 3.28125V5.44336C23.2559 6.44531 21.3574 7.92188 17.3496 11.0859C16.4531 11.7715 14.7129 13.459 13.5 13.4062C12.2344 13.459 10.4941 11.7715 9.59766 11.0859C5.58984 7.92188 3.69141 6.44531 2.53125 5.44336V3.28125H24.4688ZM2.53125 18.4688V8.71289C3.69141 9.66211 5.43164 11.0332 8.01562 13.0898C9.17578 13.9863 11.2324 15.9902 13.5 15.9375C15.7148 15.9902 17.7188 13.9863 18.9316 13.0898C21.5156 11.0332 23.2559 9.66211 24.4688 8.71289V18.4688H2.53125Z",
    fill: "#FF7000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailOrange);
export default __webpack_public_path__ + "static/media/mail-orange.88670348ded5d1fe4a52bcd5d3e74107.svg";
export { ForwardRef as ReactComponent };